import { useTranslation } from 'react-i18next';
import AuthMenu from '../components/auth/AuthMenu';
import { Instagram, Menu, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { loadLanguage } from '../i18n';
import { useConsent } from '../context/ConsentContext';
import logoImage80 from '../assets/logo.jpg?w=80&format=jpg&imagetools';
import logoImage160 from '../assets/logo.jpg?w=160&format=jpg&imagetools';
import logoImage240 from '../assets/logo.jpg?w=240&format=jpg&imagetools';
import { Helmet } from 'react-helmet-async';


export default function TermsOfService() {
  const { t, i18n } = useTranslation();
  const { openManager } = useConsent();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => { document.documentElement.lang = i18n.language; }, [i18n.language]);
  return (
    <div className="min-h-screen bg-black text-gray-200">
       <Helmet>
  <title>Όροι Χρήσης | 210 Tattoo Athens</title>
  <meta name="description" content="Όροι χρήσης της ιστοσελίδας 210 Tattoo Athens." />
  <link rel="canonical" href="https://210tattoo.gr/terms" />
  <meta name="robots" content="noindex, follow" />
</Helmet>
      <nav className="fixed top-0 w-full bg-black/95 backdrop-blur-sm z-50 border-b border-pink-600/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-24">
            <div className="flex-shrink-0 flex items-center">
              <a href="/" className="flex items-center gap-3">
                <picture>
                  <source srcSet={`${logoImage80} 1x, ${logoImage160} 2x, ${logoImage240} 3x`} type="image/jpeg" />
                  <img src={logoImage80} srcSet={`${logoImage80} 1x, ${logoImage160} 2x, ${logoImage240} 3x`} alt="210 Tattoo Studio" className="h-20 w-auto rounded-lg object-contain" width={80} height={80} loading="eager" decoding="async" />
                </picture>
              </a>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-8">
                <a href="/#home" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.home')}</a>
                <a href="/#about" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.about')}</a>
                <a href="/#services" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.services')}</a>
                <a href="/#gallery" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.gallery')}</a>
                <a href="/#faq" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.faq')}</a>
                <a href="/#contact" className="px-3 py-2 text-sm font-medium text-gray-300 hover:text-pink-400">{t('nav.contact')}</a>
                <div className="flex items-center gap-2 pl-4 border-l border-pink-600/20">
                  <button onClick={() => loadLanguage('el')} className={`px-2 py-1 text-xs rounded ${i18n.language === 'el' ? 'bg-pink-600 text-white' : 'text-gray-300 hover:text-white'}`}>ΕΛ</button>
                  <button onClick={() => loadLanguage('en')} className={`px-2 py-1 text-xs rounded ${i18n.language === 'en' ? 'bg-pink-600 text-white' : 'text-gray-300 hover:text-white'}`}>EN</button>
                </div>
                <a href="https://www.instagram.com/210tattoo/" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-2 shadow-lg hover:shadow-pink-500/25">
                  <Instagram size={16} />
                  {t('nav.dmCta')}
                </a>
                <AuthMenu />
              </div>
            </div>
            <div className="md:hidden flex items-center gap-2">
              <AuthMenu />
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-300 hover:text-white p-2" aria-label={isMenuOpen ? t('nav.closeMenu') : t('nav.openMenu')} aria-expanded={isMenuOpen} aria-controls="mobile-menu">
                {isMenuOpen ? <X size={24} aria-hidden /> : <Menu size={24} aria-hidden />}
              </button>
            </div>
          </div>
        </div>
        {isMenuOpen && (
          <div id="mobile-menu" className="md:hidden bg-black border-t border-pink-600/20">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {['home','about','services','gallery','faq','contact'].map((id) => (
                <a key={id} href={`/#${id}`} className="block px-3 py-2 text-base font-medium w-full text-left text-gray-300 hover:text-pink-400">{t(`nav.${id}` as any)}</a>
              ))}
              <div className="flex items-center gap-2 mt-2 px-3">
                <button onClick={() => loadLanguage('el')} className={`px-2 py-1 text-xs rounded ${i18n.language === 'el' ? 'bg-pink-600 text-white' : 'text-gray-300 hover:text-white'}`}>ΕΛ</button>
                <button onClick={() => loadLanguage('en')} className={`px-2 py-1 text-xs rounded ${i18n.language === 'en' ? 'bg-pink-600 text-white' : 'text-gray-300 hover:text-white'}`}>EN</button>
              </div>
              <div className="grid grid-cols-2 gap-3 mt-4 px-3 pb-3 items-center justify-items-center mx-3">
                <a href="https://www.instagram.com/210tattoo/" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 px-3 py-2 rounded-lg text-base font-medium transition-all duration-200 flex items-center justify-center gap-2 justify-self-center">
                  <Instagram size={16} />
                  {t('nav.dmCta')}
                </a>
                <div className="flex justify-center justify-self-center">
                  <AuthMenu />
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-6">{t('terms.title')}</h1>
        <p className="text-gray-400 mb-8">{t('terms.updated')}</p>
        <div className="space-y-6 leading-relaxed">
          <p>{t('terms.intro')}</p>
          <h2 className="text-2xl font-semibold text-white mt-8">{t('terms.use.title')}</h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-300">
            <li>{t('terms.use.items.eligibility')}</li>
            <li>{t('terms.use.items.account')}</li>
            <li>{t('terms.use.items.acceptable')}</li>
          </ul>
          <h2 className="text-2xl font-semibold text-white mt-8">{t('terms.content.title')}</h2>
          <p>{t('terms.content.body')}</p>
          <h2 className="text-2xl font-semibold text-white mt-8">{t('terms.liability.title')}</h2>
          <p>{t('terms.liability.body')}</p>
          <h2 className="text-2xl font-semibold text-white mt-8">{t('terms.changes.title')}</h2>
          <p>{t('terms.changes.body')}</p>
        </div>
      </div>

      <footer className="bg-black py-12 border-t border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-3xl font-bold text-pink-500 mb-4">{t('footer.studio')}</h3>
            <p className="text-gray-400 mb-6">{t('footer.tagline')}</p>
            <div className="flex justify-center space-x-6 mb-8">
              <a href="https://www.instagram.com/210tattoo/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors duration-200" aria-label={t('footer.instagramLabel')}>
                <Instagram size={24} aria-hidden />
              </a>
            </div>
            <nav className="mb-8">
              <ul className="flex justify-center gap-6 text-sm">
                <li><a href="/privacy" className="text-gray-400 hover:text-pink-400 underline-offset-4 hover:underline">{t('footer.privacy')}</a></li>
                <li><a href="/cookies" className="text-gray-400 hover:text-pink-400 underline-offset-4 hover:underline">{t('footer.cookies')}</a></li>
                <li><a href="/terms" className="text-gray-400 hover:text-pink-400 underline-offset-4 hover:underline">{t('footer.terms')}</a></li>
                <li><button type="button" onClick={openManager} className="text-gray-400 hover:text-pink-400 underline-offset-4 hover:underline">{t('consent.manage')}</button></li>
              </ul>
            </nav>
            <div className="border-t border-gray-800 pt-8">
              <p className="text-gray-300 text-sm">{t('footer.rights')}</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}


